// extracted by mini-css-extract-plugin
export default {"widget":"GameModeWidget_widget__ggvJk","title":"GameModeWidget_title__DINcc","mobile-widget":"GameModeWidget_mobile-widget__J2KW4","offset":"GameModeWidget_offset__pjW7B"};